export default __webpack_public_path__ + "images/7da4f7eeffb93adf9cf2ec29a43a8b31-baltimore_desktop.webp";